import React from "react"
import Navbar from "../../components/Navbar"
import DashboardContainer from "../Dashboard/DashboardContainer"
import Card from "../../components/Card"
import EditButton from "../../components/Buttons/EditButton"
import AddIcon from "../../assets/Images/icons/AddIcon"
import Headings from "../../components/Texts/Headings"
import { InfoContainer } from "./component/InfoContainer"


const BankDetails = () => {
  const userDetails = {
    name: "Vikram Das",
    accountNumber: "0000 0000 0000 0000",
    bankName: "HDFC Bank",
    branch: "Vashi",
  }

  const { name, accountNumber, bankName, branch } = userDetails
  return (
    <>
      <Navbar isLoggedIn={true} />
      <DashboardContainer>
        <Headings
          text="Bank Details"
        />

        <Card className="py-[16px] mt-[32px] max-w-[100%] md:max-w-[70%]">
          <div className="grid grid-cols-4 gap-[24px]">
            <div className="col-span-4 flex flex-col gap-[8px]">
              <div className="flex justify-between">
                <InfoContainer title="Name" value={name} />
                <EditButton
                  title="Update"
                  variant="secondary"
                  className="!border-primary font-[600] text-primary"
                />
              </div>
              <InfoContainer
                title="Bank Account Number"
                value={accountNumber}
              />
              <InfoContainer title="Bank Name" value={bankName} />
              <InfoContainer title="Branch" value={branch} />
            </div>
          </div>
        </Card>
        <div className="flex items-center font-Apparat font-[600] text-[14px] md:text-[18px]  leading-[20px] md:eading-[24px] mt-[30px] text-[#000]">
          <span>Add Secondary Bank</span>
          <span className="ml-[17px]">
            <AddIcon className="h-[19px] w-[19px] md:h-[23px] md:w-[23px] text-primary  rounded-full" />
          </span>
        </div>
      </DashboardContainer>
    </>
  )
}

export default BankDetails
